// PDP页面拿sku image gallery第一张图
export const usePdpImageUrl = (sku = {}) => {
    return sku?.product?.firstImage??sku?.product?.image?.[0]??"";
}